export const SiteHeader = () => (
  <header className="fixed top-1 left-0 w-full z-40 backdrop-blur-md bg-[#FBF9F5]/70">
    <div className="max-w-6xl mx-auto px-6 py-4 flex items-center gap-2">
      <div
        className="w-6 h-6 rounded-full border-2 border-[#4A6B56]"
        style={{ boxShadow: "inset 3px 3px 0 rgba(196,123,94,0.5)" }}
      />
      <span className="font-serif text-lg text-[#1E2D24] tracking-wide" data-testid="site-brand-logo">
        Aurea Soul
      </span>
    </div>
  </header>
);
